const ButtonComp = () => {
return(
<div className='button--wrapper'>
  <button id="get-in-touch">Get in Touch</button>  
</div>
)
}
export {ButtonComp}